import request from "@/service";

// 获取微视频列表
export function shortVideoList(data) {
  return request({
    url: `/resource/short/video/page`,
    method: "get",
    params: data
  });
}

// 删除微视频
export function shortVideoDelete(data) {
  return request({
    url: `/resource/short/video/delete`,
    method: "delete",
    data
  });
}

// 新增微视频
export function shortVideoSave(data) {
  return request({
    url: `/resource/short/video/save`,
    method: "post",
    data
  });
}

// 获取微视频详情
export function shortVideoInfo(data) {
  return request({
    url: `/resource/short/video/info/${data}`,
    method: "get"
  });
}

// 修改微视频
export function shortVideoEdit(data) {
  return request({
    url: `/resource/short/video/update`,
    method: "put",
    data
  });
}

// 微视频上下线
export function shortVideoOnline(data) {
  return request({
    url: `/resource/short/video/online`,
    method: "put",
    data
  });
}

// 微视频是否置顶
export function shortVideoTop(data) {
  return request({
    url: `/resource/short/video/top`,
    method: "put",
    data
  });
}
